import { useState } from "react";
import AdminBackoffice from "../AdminBackoffice/AdminBackoffice";
import AdminPanel from "./AdminPanel";
import AdminVersionChooser from "./components/AdminVersionChooser/AdminVersionChooser";
import AdminVersionSwitch from "./components/AdminVersionSwitch/AdminVersionSwitch";
import { ADMIN_VERSIONS, getStoredAdminVersion, storeAdminVersion } from "./config/adminVersion";

// Decide entre o admin clássico e o novo. A escolha fica salva e pode ser trocada a qualquer momento.
const AdminEntry = ({ userType }) => {
  const [version, setVersion] = useState(getStoredAdminVersion);

  const chooseVersion = (nextVersion) => {
    storeAdminVersion(nextVersion);
    setVersion(nextVersion);
    window.scrollTo(0, 0);
  };

  if (!version) return <AdminVersionChooser onChoose={chooseVersion} />;

  if (version === ADMIN_VERSIONS.NEW) {
    return (
      <AdminPanel userType={userType} onSwitchVersion={() => chooseVersion(ADMIN_VERSIONS.CLASSIC)} />
    );
  }

  return (
    <>
      <AdminBackoffice userType={userType} />
      <AdminVersionSwitch onClick={() => chooseVersion(ADMIN_VERSIONS.NEW)} />
    </>
  );
};

export default AdminEntry;
